/**
 * Loads Stripe.js on every page, as Stripe recommends for its fraud signals,
 * but only after the page has rendered.
 *
 * Importing @stripe/stripe-js injects the script as a side effect. While the
 * checkout was part of the main bundle that happened at startup, so every
 * visit fetched and ran ~270 KB of third-party script (plus its iframe)
 * alongside the app's own first render. The checkout is now loaded on demand
 * and imports it itself; this keeps it on the other pages, off the critical
 * path.
 */

/** After the load event, out of the way of the first content render. */
export const STRIPE_PRELOAD_DELAY_MS = 3000;

export function loadStripeAfterRender(): void {
  const start = () => {
    void import("@stripe/stripe-js");
  };
  const schedule = () => {
    setTimeout(() => {
      if (typeof window.requestIdleCallback === "function") {
        window.requestIdleCallback(start, { timeout: 2000 });
      } else {
        start();
      }
    }, STRIPE_PRELOAD_DELAY_MS);
  };

  if (document.readyState === "complete") {
    schedule();
  } else {
    window.addEventListener("load", schedule, { once: true });
  }
}
